export default __webpack_public_path__ + "static/media/controls_touch_1.e5647b31.svg";